<ng-container *ngVar="editing$ | async as editing">
  <div *ngVar="trustCenterInfo$ | async as trustCenterInfo" class="flex flex-col gap-4">
    <div *ngVar="trustCenterInfo?.title as title" class="flex justify-between items-center">
      <div class="title font-main text-6xl font-extrabold text-navy-90 flex-1 gap-4">
        {{ title ? trustCenterInfo?.title : (buildTranslationKey('overview.titleMissing') | translate) }}
      </div>

      @if (editing) {
        <app-icon-button
          [svgIconPath]="'edit'"
          [type]="'basic'"
          [iconSize]="'small'"
          (click)="openEditOverviewSidepanel()"
        ></app-icon-button>
      }
    </div>

    <ng-container *ngVar="trustCenterInfo?.overview as overview">
      @if (overview) {
        <app-formatted-text
          class="text-navy-80 text-3xl font-normal line whitespace-pre-line"
          [text]="overview"
        ></app-formatted-text>
      }

      @if (!overview && editing) {
        <div class="text-navy-70 text-3xl font-normal line whitespace-pre-line">
          {{ buildTranslationKey('overview.missing') | translate }}
        </div>
      }
    </ng-container>
  </div>
</ng-container>
